module.exports = __webpack_public_path__ + "images/icon_minimize_7f4f5a538d81e6b81d22fadc26c3fdc9.svg";